import { TypographyProps } from '@mui/material';

import { StyledTypography } from './styles';

export type TCustomTypography = TypographyProps;

export const CustomTypography = ({
  variant = 'body1',
  color,
  children,
  ...props
}: TCustomTypography) => {
  return (
    <StyledTypography variant={variant} color={color} {...props}>
      {children}
    </StyledTypography>
  );
};
